import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";
import { main } from '@angular/compiler-cli/src/main';

@Injectable({
	providedIn: "root",
})
export class NavigationService {
	public backEnabled: boolean;
	private routeString = "";
	private version: string;
	private activeIndex: number | null;
	private sideNavKey = 'sideNavState';
	private collapsedKey = 'sideNavCollapsed';
	navMenuItems: any;

	public sideNavOpen = new BehaviorSubject<boolean>(true);
	// private sideNavOpen: Observable<boolean> = false; // TODO: Read prev value from session / local storage
	public isCollapsed = new BehaviorSubject<boolean>(false);

	constructor(private router: Router) {
		this.loadState();
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(() => {
				this.updateNavMenuItems();
			});
	}

	public GetCurrentRoute = (): string => {
		return this.router.url;
	};

	public SetCurrentRoute = (route: string) => {
		this.routeString = route;
	};

	public SideNavClosed = () => {
		this.sideNavOpen.next(false);
	};

	public SideNavOpened = () => {
		this.sideNavOpen.next(true);
	};

	public IsSideNavOpen = (): boolean => {
		return this.sideNavOpen.getValue();
	};

	public GetSideNav(callback: (val) => void) {
		return this.isCollapsed.subscribe((val) => {
			if (callback != null) {
				callback(val);
			}
		});
	}

	public Navigate = (url: string, queryParams?) => {
		// this.nav.remove(this.nav.last().index)
		//     .then(
		//       () => {
		//         this.nav.push(DetailPage, {
		//           itemID
		//         });
		//       },
		//       error => {}
		//     );

		const currUrl = this.router.url.split("/");

		if (
			queryParams != null &&
			currUrl[currUrl.length - 2] == "Devices" &&
			currUrl[currUrl.length - 1] == "Details"
		) {
			queryParams["replaceUrl"] = true;
		} else if (
			queryParams == null &&
			currUrl[currUrl.length - 2] == "Devices" &&
			currUrl[currUrl.length - 1] == "Details"
		) {
			queryParams = {
				replaceUrl: true,
			};
		}
		// console.log(url)
		this.router.navigate([url], queryParams);
	};

	saveState() {
		if (this.navMenuItems) {
			sessionStorage.setItem(this.sideNavKey, JSON.stringify(this.navMenuItems));
		} else {
			sessionStorage.removeItem(this.sideNavKey);
		}

		if (this.isCollapsed) {
			sessionStorage.setItem(this.collapsedKey, JSON.stringify(this.isCollapsed.getValue()));
		}
	}

	loadState() {
		const savedState = sessionStorage.getItem(this.sideNavKey);
		this.navMenuItems = savedState ? JSON.parse(savedState) : undefined;

		const savedCollapsed = sessionStorage.getItem(this.collapsedKey);
		const tempCollapsed = savedCollapsed ? JSON.parse(savedCollapsed) : false;
		this.isCollapsed.next(tempCollapsed);
	}

	public ClearState(): void {
		sessionStorage.removeItem(this.sideNavKey);
		sessionStorage.removeItem(this.collapsedKey);
		this.navMenuItems = undefined;
		this.isCollapsed.next(false);
	}

	public GetActiveIndex = (): number => {
		return this.activeIndex;
	};

	public SetActiveIndex = (index: number) => {
		this.activeIndex = index;
	};

	public GetIsCollapsed = (): boolean => {
		return this.isCollapsed.getValue();
	};

	public SetIsCollapsed = (isCollapsed: boolean) => {
		this.isCollapsed.next(isCollapsed);
		this.saveState();
	};

	public SetMenuItems = (menuItems: any) => {
		this.navMenuItems = menuItems;
		this.saveState();
	};

	public GetMenuItems = (): boolean => {
		return this.navMenuItems;
	};

	public UpdateMenuItem = (menuItem: any, index: number) => {
		this.navMenuItems['menuItems'][index] = menuItem;
		this.saveState();
	};

	public deactivateMenuItems = () => {
		this.navMenuItems?.menuItems.forEach(mainMenuItem => {
		  mainMenuItem.active = false;
		  mainMenuItem.Open = false;
		  if(mainMenuItem.menuItems){
			mainMenuItem.menuItems.forEach(subMenuItem => {
			  subMenuItem.active = false;
			});
		  }
		});
		this.saveState();
	};

	public updateNavMenuItems() {
		const currentRoute = this.router.url; // Get the current route
		// You can use the current route to determine which menu item should be active
		if (this.navMenuItems) {
			this.navMenuItems.menuItems.forEach(mainMenuItem => {
				// Update active state of menu items based on currentRoute
				mainMenuItem.active = currentRoute.includes(mainMenuItem.link);
        mainMenuItem.Open = mainMenuItem.active;
				if (mainMenuItem.menuItems) {
					mainMenuItem.menuItems.forEach(subMenuItem => {
						subMenuItem.active = currentRoute.includes(subMenuItem.link);
					});
				}
			});
			this.saveState();
		}
	}

}
